import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import DietsAllergensGold from '../../../svg/DietsAllergensGold.js';
import Formsy from 'formsy-react';
import FormsyInputMui from '../../form/FormsyInputMui';

class OtherAllergens extends Component {
  state = {
    client: {
      other_allergens: ''
    },
    isCurrentStep: false
  };
  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const { other_allergens } = this.state.client;
    const { isCurrentStep } = this.state;

    return (
      <React.Fragment>
        <InfoBox
          headline="Any other allergies we should know about?"
          icon={<DietsAllergensGold className="onboarding-new__icon--top" />}
          isHeadlineOnTop={false}
        />
        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
        >
          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="other_allergens"
                placeholder="Other Allergies"
                value={other_allergens}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                multiline
                rowsMax="10"
              />
            </div>
          </div>
        </Formsy>
      </React.Fragment>
    );
  }

  handleChange = e => {
    const { name, value } = e.target;
    if (value.length <= 350) {
      this.setState({ client: { ...this.state.client, [name]: value } });
    }
  };

  handleClientUpdate = () => {
    const { client } = this.state;
    this.props.updateClient(client);
  };

  componentDidMount() {
    const { client } = this.props;
    this.setState({ client });
  }

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep = false, client } = this.props;

    if (prevProps.client !== client) this.setState({ client });

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }
}

export default OtherAllergens;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/OtherAllergens.js